import ReactDOM from 'react-dom';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import squareBackgroundImage from '../../../images/bg-square-2x.png';
import playerBackgroundImage from '../../../images/blue-blob-bg-1440.png';
import checkMark from '../../../images/yellow-check-mark.png';
import Iframe from './iframe';

const POLLING_DURATION = 3000;

const ShowItemBankQuiz = (props) => {
  const [started, setStarted] = useState(false);
  const pollingInterval = useRef();

  const fromPlayer = props.from === 'player';
  const fromPublishedCollection = props.from === 'published-collection';

  const stopPolling = () => {
    if (!props.sharedPlayerId) return;
    clearInterval(pollingInterval.current);
  };

  useEffect(() => {
    if (props.onRender) {
      props.onRender();
    }
    return () => {
      stopPolling();
    };
  }, []);

  useEffect(() => {
    if (started && props.sharedPlayerId) {
      pollingInterval.current = setInterval(async () => {
        const response = await fetch(
          `/quizzes/${props.id}/finished?shared_player_id=${props.sharedPlayerId}&context_id=${props.contextId}`
        );
        const json = await response.json();
        if (json.finished === true) {
          props.onFinish();
          stopPolling();
        }
      }, POLLING_DURATION);
    } else {
      stopPolling();
    }
  }, [started, props.sharedPlayerId]);

  const start = () => {
    if (props.onStart) props.onStart();
    setStarted(true);
  };

  const loadHandler = () => {
    if (props.onLoad) {
      props.onLoad();
    }
  };

  let backgroundImage;
  let imgOrIframeClassName = 'absolute ';
  switch (props.from) {
    case 'player':
      backgroundImage = playerBackgroundImage;
      imgOrIframeClassName += `w-11/12 md:w-8/12 2xl:w-10/12 ${
        started ? 'rounded' : 'h-full'
      }`;
      break;
    case 'published-collection':
      backgroundImage = playerBackgroundImage;
      imgOrIframeClassName += 'h-full w-full top-0';
      break;
    default:
      backgroundImage = squareBackgroundImage;
      imgOrIframeClassName += 'h-[85%] w-[90%] top-[70px]';
  }

  const showQuizSrc = `/quizzes/${props.id}${
    props.sharedPlayerId
      ? `?shared_player_id=${props.sharedPlayerId}&context_id=${props.contextId}`
      : ''
  }`;

  const content = (
    <div
      id={`quiz-${props.id}-${props.contextId}`}
      className={`flex items-center justify-center h-full ${
        fromPublishedCollection && !started ? 'relative p-24' : ''
      }`}
    >
      {started ? (
        <>
          <Iframe
            src={showQuizSrc}
            className={`${imgOrIframeClassName} ${
              fromPublishedCollection || (fromPlayer && started)
                ? 'min-h-[500px] relative'
                : ''
            }`}
            height={fromPlayer ? '90%' : '100%'}
            onLoad={loadHandler}
          />
        </>
      ) : (
        <>
          <img
            src={backgroundImage}
            className={imgOrIframeClassName}
            onLoad={loadHandler}
          />
          <div className="text-white text-center z-10">
            <i className="fa-regular fa-comments-question-check fa-3x" />
            <h2 className={fromPlayer ? 'mt-8' : 'mt-16'}>{props.title}</h2>
            {props.finished ? (
              <>
                <p className="text-lg -mt-3 pl-14">
                  You&apos;ve completed this quiz{' '}
                  <img src={checkMark} className="-ml-4 h-24 inline-block" />
                </p>
              </>
            ) : (
              <button
                className="mt-4 border border-white rounded py-4 px-16 hover:bg-sky-700"
                onClick={start}
              >
                Start
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );

  if (!fromPublishedCollection) return content;

  return (
    <div className="panel-container">
      <div className="react-notifications-root" />
      <div className="panel-heading clearfix">
        <div
          id={`add-to-folder-button-${props.id}-${props.contextId}`}
          className="add-to-folder-btn-container"
        ></div>
      </div>
      {content}
    </div>
  );
};

ShowItemBankQuiz.propTypes = {
  title: PropTypes.string,
  noOfQuestions: PropTypes.number,
  from: PropTypes.string,
  id: PropTypes.number,
  onStart: PropTypes.func,
  onFinish: PropTypes.func,
  finished: PropTypes.bool,
  onRender: PropTypes.func,
  onLoad: PropTypes.func,
  sharedPlayerId: PropTypes.number,
  contextId: PropTypes.number
};

ShowItemBankQuiz.render = (root, props) => {
  if (document.getElementById(`quiz-${props.id}-${props.contextId}`)) return;
  ReactDOM.createRoot(root).render(React.createElement(ShowItemBankQuiz, props));
};

export default ShowItemBankQuiz;
